import {jsx} from 'panel';

import {ButtonSize, ButtonTheme, ButtonType} from 'common/components/button/constants';
import {SvgIconEl} from 'common/components/svg-icon';
import {ControlBarEl} from 'common/widgets/control-bar';
import {MetricType} from 'common/query-builder/query-block/constants';
import {ReportName} from 'common/report/constants';
import {ButtonEl} from 'common/components/button';

import {ControlBarAction, ControlBarActionItems} from '../constants';
import {Action, MetricEntry} from '../types';
import type {QueryEntrySection} from '../index';

const MetricTypeIconMap: {[key in MetricType]: string} = {
  [MetricType.Event]: `brand-insights`,
  [MetricType.CustomEvent]: `brand-insights`,
  [MetricType.Funnel]: `brand-funnels`,
  [MetricType.Retention]: `brand-retention`,
  [MetricType.RetentionFrequency]: `brand-retention`,
  [MetricType.People]: `brand-insights`,
  [MetricType.Cohort]: `brand-insights`,
  [MetricType.Formula]: `formula-scroll`,
};

export function MetricHeader({el, entry, index}: {el: QueryEntrySection; entry: MetricEntry; index: number}) {
  const {isExpanded} = entry;
  const metricName = entry.behavior.renamed || entry.behavior.name || `Untitled`;
  const overflowControls = [ControlBarActionItems[ControlBarAction.Rename]];
  if (el.attr(`report-name`) === ReportName.Insights) {
    overflowControls.push(ControlBarActionItems[ControlBarAction.Duplicate]);
    overflowControls.push(ControlBarActionItems[ControlBarAction.Delete]);
  }

  return (
    <div sel='.mp-metric-entry-header'>
      <SvgIconEl sel='.mp-metric-entry-header-icon' attrs={{icon: MetricTypeIconMap[entry.behavior.type]}} />
      <div
        sel='.mp-metric-entry-header-name'
        attrs={{
          title: metricName,
        }}
      >
        {metricName}
      </div>
      <div sel='.mp-metric-entry-header-actions'>
        <ButtonEl
          sel='.expand-control'
          attrs={{
            icon: isExpanded ? `collapse-diagonal` : `expand`,
            theme: ButtonTheme.Tertiary,
            size: ButtonSize.Medium,
            tooltip: {
              text: isExpanded ? `Collapse` : `Expand`,
            },
          }}
          on={{
            click: () => el.toggleExpandedRow(index),
          }}
        />
        {el.attr(`report-name`) === ReportName.Insights && (
          <ButtonEl
            attrs={{
              elref: `deleteLineButton`,
              theme: ButtonTheme.Tertiary,
              icon: `x`,
              role: `button`,
              type: ButtonType.Destructive,
              tooltip: {
                text: `Remove`,
              },
            }}
            on={{
              click: () => el.helpers.onEventActionClick(Action.Remove, index),
            }}
          />
        )}
        <ControlBarEl
          attrs={{
            elref: `metricRowControlBar`,
            theme: ButtonTheme.Tertiary,
            'overflow-icon': `ellipsis`,
            'overflow-controls': [
              {
                items: overflowControls,
              },
            ],
          }}
          on={{
            select: (ev: CustomEvent) => el.helpers.onControlSelect(ev.detail.value, index),
          }}
        />
      </div>
    </div>
  );
}
